module.exports = __webpack_public_path__ + "static/Postgres-bdceb0e5c25e32eb77f26efd8380b5ae.svg";